<template>
	<div class="list-container">
		<table class="view-table view-table--action" cellspacing="0">
			<thead>
				<tr>
					<th>Sr. No.</th>
					<th>Date</th>
					<th>Name<br>Company</th>
					<th>Contact No.<br>Email</th>
					<th>Products<br>Services</th>
					<th>Budget</th>
					<th>Source</th>
					<th>Last Follow-up</th>
					<th>Assigned to</th>
					<th>Status</th>
					<th>Action</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(row, index) in leadArray" :key="row.id">
					<td :data-label="row.Name">
						{{ reverseSerial(leadArray,index) }}.
						<Action MobileAction :ActionObject="row" :ActionList="ActionList"/>
					</td>
					<td data-label="Date">
						<div>{{ row.Date }}</div>
					</td>
					<td data-label="Company">
						<div class="desktop">{{ row.Name }}</div>
						<div>{{ row.Company }}</div>
					</td>
					<td data-label="Contact No. / Email">
						<div v-for="number in row.ContactNo" :key="number.id">{{ number }}</div>
						<div v-for="email in row.Email" :key="email.id">{{ email }}</div>
					</td>
					<td data-label="Products / Services">
						<div>
							<div v-for="productservice in row.ProductsServices" :key="productservice.id">{{ productservice }}</div>
						</div>
					</td>
					<td data-label="Budget">
						<div>{{ row.Budget }}</div>
					</td>
					<td data-label="Source">
						<div>{{ row.Source }}</div>
					</td>
					<td data-label="Last Follow-up">
						<div>{{ row.LastFollowUp }}</div>
						<div><span class="badge badge-secondary">{{ getDaysAgo(new Date(row.LastFollowUp)) }} days ago</span></div>
					</td>
					<td data-label="Assigned to">
						<div>{{ row.AssignedTo }}</div>
					</td>
					<td data-label="Status"><div><span class="badge" :class="'badge-'+row.Status.badge">{{ row.Status.message }}</span></div></td>
					<td data-label="Action">
						<Action :ActionObject="row" :ActionList="ActionList"/>
					</td>
				</tr>
			</tbody>
		</table>
		<ActionModals :module="modulePrefix"/>
	</div>
</template>

<script>
// @ is an alias to /src
import Action from '@/components/table/Action.vue'
import ActionModals from '@/components/table/ActionModals.vue'

export default {
	name: 'view-leads',
	components: {
		Action,
		ActionModals
	},
	data() {
		return {
			modulePrefix: "lead",
			ActionList: [
			'viewEdit',
			'status',
			'call',
			'meeting',
			'sms',
			'email',
			'delete'
			],
			leadArray: [
			{
				Id: "L6",
				Date: "13 Dec 2018",
				Name: "Charles Cooper",
				Company: "Hangar Pvt. Ltd",
				ContactNo: ["9231457895"],
				Email: ["charles@hangar.com"],
				ProductsServices: ["Product 1","Service 2"],
				Budget: "45,000",
				Source: "Website",
				LastFollowUp: "23 Dec 2018",
				AssignedTo: "Rachel Castro",
				Status: {badge:"warning",message:"Negotiating"}
			},
			{
				Id: "L5",
				Date: "25 Nov 2018",
				Name: "Stephen Clark",
				Company: "Smart Ltd",
				ContactNo: ["9231457895"],
				Email: ["stephen@smart.com"],
				ProductsServices: ["Product 2","Product 3"],
				Budget: "1,65,000",
				Source: "Newspaper",
				LastFollowUp: "1 Dec 2018",
				AssignedTo: "Rachel Castro",
				Status: {badge:"danger",message:"Followup"}
			},
			{
				Id: "L4",
				Date: "20 Oct 2018",
				Name: "Russell Lee",
				Company: "Rus Corp",
				ContactNo: ["9231451423","022-8694237"],
				Email: ["russell@rcorp.com"],
				ProductsServices: ["Product 1","Product 4"],
				Budget: "97,000",
				Source: "Website",
				LastFollowUp: "1 Dec 2018",
				AssignedTo: "Austin Hicks",
				Status: {badge:"warning",message:"Negotiating"}
			},
			{
				Id: "L3",
				Date: "20 Oct 2018",
				Name: "Rachel Wood",
				Company: "CC Corp.",
				ContactNo: ["022 8694237"],
				Email: ["rachel@ccc.com"],
				ProductsServices: ["Service 2"],
				Budget: "2,50,000",
				Source: "Website",
				LastFollowUp: "1 Dec 2018",
				AssignedTo: "Rachel Castro",
				Status: {badge:"info",message:"Discussing"}
			},
			{
				Id: "L2",
				Date: "10 Nov 2018",
				Name: "Joel Hill",
				Company: "Rhyta Corp",
				ContactNo: ["9212678992"],
				Email: ["joelbhill@rhyta.com"],
				ProductsServices: ["Product 2"],
				Budget: "2,25,000",
				Source: "Newspaper",
				LastFollowUp: "24 Nov 2018",
				AssignedTo: "Austin Hicks",
				Status: {badge:"success",message:"New"}
			},
			{
				Id: "L1",
				Date: "1 Sep 2018",
				Name: "Kevin Harris",
				Company: "WebTech",
				ContactNo: ["9212678992"],
				Email: ["kevin@wtech.com"],
				ProductsServices: ["Product 1"],
				Budget: "1,45,000",
				Source: "Website",
				LastFollowUp: "20 Dec 2018",
				AssignedTo: "Austin Hicks",
				Status: {badge:"success",message:"New"}
			}
			]
		}
	},
	computed: {

	},
	mounted() {
		
	},
	methods: {
		getDaysAgo: function(date) {
			let today = new Date();
			let utc1 = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
			let utc2 = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
			return Math.floor((utc2 - utc1) / (1000*60*60*24));
		}
	}
}
</script>
